import {  
    getFirestore, 
    query, 
    getDoc,
    doc,
    collection,
    getDocs
} from "firebase/firestore";
const getQuizList = async function(quizId) {

    let db = getFirestore();
    let quizRef = collection(db, "wellness_quiz");
    if( quizId != undefined ){
        quizRef = doc(db, "wellness_quiz", quizId );
        const docSnapa = await getDoc(quizRef);
        return {...docSnapa.data(), ... { id: docSnapa.id }};
    }
    else{
        const quizQuery = query( 
            quizRef
        );
        
        const docSnap = (await getDocs(quizQuery));
        const quizList = [];
        if( docSnap.size ){
            docSnap.forEach( async (doc) => {
                quizList.push({
                    ...doc.data(),
                    ...{ id: doc.id }
                });
            });
        }
        return quizList;
    }
};
export default getQuizList;